import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { companyChoice } from '../constants/appConstants';
import useMyCompanies from '../tenancy/useMyCompanies';
import { COMPANIES_PATH, PICKER_PATH } from '../tenancy/companies';

const DISMISSED_KEY = 'companyInviteBannerDismissed';
// Where the banner has nothing to add: before sign-in, and on the screens that
// already list the invitations (Settings points to the page that does).
const HIDDEN_ON = ['/', PICKER_PATH, '/userProfile', COMPANIES_PATH];

/** "You have been invited to another company", for a person with a pending invite. */
export default function CompanyInviteBanner() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { myCompanies } = useMyCompanies();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISSED_KEY) === '1');
  const count = myCompanies?.pendingInvites?.length ?? 0;

  if (!count || dismissed || HIDDEN_ON.includes(pathname)) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, '1');
    setDismissed(true);
  };

  return (
    <Alert
      severity="info"
      role="status"
      // An `action` replaces MUI's own close button, so both live here.
      action={
        <>
          <Button color="inherit" size="small" onClick={() => navigate(COMPANIES_PATH)}>
            {companyChoice.VIEW_INVITES}
          </Button>
          <IconButton aria-label="close" color="inherit" size="small" onClick={dismiss}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
      sx={{ position: 'fixed', bottom: 16, left: 16, zIndex: 1300, maxWidth: 420 }}
    >
      {companyChoice.INVITE_BANNER(count)}
    </Alert>
  );
}
